import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { StyledAvatar } from './styled/avatar'
import RenderIf from '../render-if'

const Avatar = (props) => {
  const {
    style,
    backgroundColor,
    className,
    textColor,
    width,
    height,
    userInfo,
    onClick,
  } = props

  // 取名字前五位
  const handleAvatarText = (name) => {
    if (name && name.length >= 5) return name.substring(0, 6)
    return name
  }

  return (
    <StyledAvatar
      style={style}
      backgroundColor={backgroundColor}
      className={className}
      textColor={textColor}
      width={width}
      height={height}
      onClick={onClick}
    >
      <RenderIf isTrue={userInfo.avatar}>
        <img src={userInfo.avatar} alt="" />
      </RenderIf>
      <RenderIf isTrue={!userInfo.avatar}>
        <span className={clsx(['text-light-900', 'bg-primary'])}>
          {handleAvatarText(userInfo.name)}
        </span>
      </RenderIf>
    </StyledAvatar>
  )
}

// 默认参数
Avatar.defaultProps = {
  style: {},
  backgroundColor: undefined,
  className: undefined,
  textColor: undefined,
  width: 84,
  height: 34,
  userInfo: undefined,
  onClick: null,
}

// 参数类型
Avatar.propTypes = {
  style: PropTypes.shape({}),
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  textColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  userInfo: PropTypes.shape({}),
  onClick: PropTypes.func,
}

export default Avatar
